// tslint:disable: naming-convention
import { Action } from '@ngrx/store';
import { ContractGroupTypeEntity } from '../../../entities/mdqx/contract-group-type.entity';

export enum ContractGroupTypeActionTypes {
    GetContractGroupTypeRequest = '[ContractGroupType] Get Request',
    GetContractGroupTypeResponse = '[ContractGroupType] Get Response',
}

export class GetContractGroupTypeRequest implements Action {
    readonly type = ContractGroupTypeActionTypes.GetContractGroupTypeRequest;
}

export class GetContractGroupTypeResponse implements Action {
    readonly type = ContractGroupTypeActionTypes.GetContractGroupTypeResponse;
    constructor(public Payload: ContractGroupTypeEntity[]) {}
}

export type ContractGroupTypeActions =
    | GetContractGroupTypeRequest
    | GetContractGroupTypeResponse;
